import UserList from './components/UserList';
import withStateHandlers from './containers/withStateHandlers';
import { withApollo } from 'react-apollo';
import { compose } from 'ramda';

export default compose(
  withStateHandlers,
  withApollo
)(UserList);
